"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sort = exports.loadMore = exports.getSentPackages = exports.fetchSentPackages = exports.updateTotalCount = exports.updateSort = exports.updateCurrentOffset = exports.toggleSelectUser = exports.setIsSearching = exports.refreshSentPackages = exports.getSentPackagesSuccess = exports.getSearchFiltersSuccess = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var models_1 = require("@app/_state/models");
var utils_1 = require("@app/_state/utils");
var selectors_1 = require("@app/features/transfers/state/selectors");
var PackagesApi = __importStar(require("@app/services/api/packages"));
var matomo_1 = require("@app/shared/matomo");
var createAction = typesafe_actions_1.deprecated.createAction;
/* Action Creators - begin */
exports.getSearchFiltersSuccess = createAction('@@sent_packages/GET_SEARCH_FILTERS_SUCCESS', function (resolve) { return function (users) { return resolve(users); }; });
exports.getSentPackagesSuccess = createAction('@@sent_packages/GET_PACKAGES_SUCCESS', function (resolve) { return function (packages, appendRows) { return resolve({ packages: packages, appendRows: appendRows }); }; });
exports.refreshSentPackages = createAction('@@sent_packages/REFRESH_PACKAGES');
exports.setIsSearching = createAction('@@sent_packages/SET_IS_SEARCHING', function (resolve) { return function (isSearching) { return resolve(isSearching); }; });
exports.toggleSelectUser = createAction('@@sent_packages/TOGGLE_SELECT_USER', function (resolve) { return function (userIdentifier) { return resolve(userIdentifier); }; });
exports.updateCurrentOffset = createAction('@@sent_packages/UPDATE_CURRENT_OFFSET', function (resolve) { return function (offset) { return resolve(offset); }; });
exports.updateSort = createAction('@@sent_packages/UPDATE_SORT', function (resolve) { return function (sortKey, sortDirection) { return resolve({ sortKey: sortKey, sortDirection: sortDirection }); }; });
exports.updateTotalCount = createAction('@@sent_packages/UPDATE_TOTAL_COUNT', function (resolve) { return function (totalCount) { return resolve(totalCount); }; });
/* Action Creators - end */
/* Sent Packages' Action Functions - begin */
/**
 * Get sent packages for the current user
 * @param offset Paging start index
 * @param pageSize Number of records to fetch per page
 * @param sortKey The field to sort by
 * @param sortDirection 1 ascending, -1 descending
 * @param appendRows Optional keyword search term
 * @param searchTerm Whether to append records to the state model
 * @param userIds Filter user ids
 */
var fetchSentPackages = function (offset, pageSize, sortKey, sortDirection, appendRows, searchTerm, userIds) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, searchRequest, searchPackageResponse, sentPackages;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    searchRequest = {
                        search: {
                            predicates: [{
                                    booleanOperator: 'AND',
                                    searchTerms: [
                                        {
                                            key: 'mailbox',
                                            criteria: 'outbox'
                                        },
                                        {
                                            key: 'keyword',
                                            criteria: searchTerm
                                        },
                                        {
                                            key: 'userIds',
                                            criteria: userIds
                                        }
                                    ]
                                }]
                        },
                        paging: {
                            offset: offset,
                            limit: pageSize
                        },
                        sort: {
                            field: sortKey,
                            order: sortDirection
                        }
                    };
                    return [4 /*yield*/, PackagesApi.searchPackages(searchRequest)];
                case 1:
                    searchPackageResponse = _a.sent();
                    sentPackages = utils_1.checkAsperaTransfers(state.transfers.asperaTransfers, searchPackageResponse.packages, models_1.PackageView.SENT);
                    if (selectors_1.isAsperaEnabled(state)) {
                        dispatch(exports.getSentPackagesSuccess(sentPackages, appendRows));
                    }
                    else {
                        dispatch(exports.getSentPackagesSuccess(utils_1.checkPluginlessUploads(state.pendingUploads.pendingUploads, sentPackages), appendRows));
                    }
                    dispatch(exports.updateTotalCount(searchPackageResponse.filterOptions.totalCount));
                    dispatch(exports.getSearchFiltersSuccess(searchPackageResponse.filterOptions.outboxUsers));
                    dispatch(exports.setIsSearching(false));
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.fetchSentPackages = fetchSentPackages;
var getSentPackages = function (pageSize, searchTerm) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, sortKey, sortDirection, userIds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    dispatch(exports.setIsSearching(true));
                    sortKey = state.sentPackages.sortKey;
                    sortDirection = state.sentPackages.sortDirection;
                    userIds = state.sentPackages.selectedUsers;
                    return [4 /*yield*/, dispatch(exports.fetchSentPackages(0, pageSize, sortKey, sortDirection, false, searchTerm, userIds))];
                case 1:
                    _a.sent();
                    dispatch(exports.updateCurrentOffset(0));
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.getSentPackages = getSentPackages;
var loadMore = function (pageSize, searchTerm) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, offset, sortKey, sortDirection, userIds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    dispatch(exports.setIsSearching(true));
                    offset = state.sentPackages.currentOffset;
                    sortKey = state.sentPackages.sortKey;
                    sortDirection = state.sentPackages.sortDirection;
                    userIds = state.sentPackages.selectedUsers;
                    return [4 /*yield*/, dispatch(exports.fetchSentPackages(offset + pageSize, pageSize, sortKey, sortDirection, true, searchTerm, userIds))];
                case 1:
                    _a.sent();
                    dispatch(exports.updateCurrentOffset(offset + pageSize));
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.loadMore = loadMore;
var sort = function (sortKey, pageSize, searchTerm) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var state, currentSortKey, currentSortDirection, userIds, sortDirection;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = getState();
                    dispatch(exports.setIsSearching(true));
                    currentSortKey = state.sentPackages.sortKey;
                    currentSortDirection = state.sentPackages.sortDirection;
                    userIds = state.sentPackages.selectedUsers;
                    sortDirection = -1;
                    if (sortKey === currentSortKey) {
                        sortDirection = currentSortDirection * -1;
                    }
                    dispatch(exports.updateCurrentOffset(0));
                    dispatch(exports.updateSort(sortKey, sortDirection));
                    new matomo_1.MatomoTracker().trackEvent('Sent Packages', 'Sort', sortKey + " - " + ((sortDirection > 0) ? 'ascending' : 'descending'));
                    return [4 /*yield*/, dispatch(exports.fetchSentPackages(0, pageSize, sortKey, sortDirection, false, searchTerm, userIds))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
};
exports.sort = sort;
/* Sent Packages' Action Functions - end */
